import Marquee from "react-fast-marquee";
import { CLIENT_LOGOS } from "@/data/site";

export default function ClientMarquee() {
  return (
    <section className="border-y border-dq-line/70 bg-white py-10" data-testid="client-logos">
      <div className="dq-container">
        <p className="mb-7 text-center text-xs font-semibold uppercase tracking-[0.22em] text-dq-muted">
          Trusted by growing businesses across Bengaluru
        </p>
      </div>
      <Marquee gradient gradientColor="#FFFFFF" gradientWidth={90} speed={40} pauseOnHover>
        {CLIENT_LOGOS.map((name) => (
          <span key={name} className="mx-10 font-display text-xl font-bold tracking-tight text-dq-ink/35 transition-colors hover:text-dq-ink/70 sm:text-2xl">
            {name}
          </span>
        ))}
      </Marquee>
    </section>
  );
}
